/**
 * PayPal's `language_COUNTRY` for the page's language. Without one, PayPal
 * picks a language from the buyer's location and browser (e.g. French on
 * reebelo.es), so every live store's languages are pinned, English included.
 */
const PAYPAL_LOCALES: Record<string, string> = {
  fr: 'fr_FR',
  de: 'de_DE',
  es: 'es_ES',
  it: 'it_IT',
  nl: 'nl_NL',
  sv: 'sv_SE',
  pt: 'pt_PT',
  fi: 'fi_FI',
};

// Where the store's country differs from the language's main one.
const STORE_PAYPAL_LOCALES: Partial<Record<string, Record<string, string>>> = {
  'reebelo-us': { en: 'en_US' },
  'reebelo-ca': { en: 'en_CA', fr: 'fr_CA' },
  'reebelo-uk': { en: 'en_GB' },
  'reebelo-ie': { en: 'en_IE' },
  'reebelo-au': { en: 'en_AU' },
  'reebelo-nz': { en: 'en_NZ' },
  quista: { en: 'en_SG' },
  'reebelo-at': { de: 'de_AT' },
  'reebelo-be': { fr: 'fr_BE', nl: 'nl_BE' },
};

export const getPayPalLocale = (
  store: string,
  locale: string | undefined,
): string | undefined =>
  locale
    ? STORE_PAYPAL_LOCALES[store]?.[locale] ?? PAYPAL_LOCALES[locale]
    : undefined;

/**
 * The Pay Later message's own `language`. Messages ignore the SDK `locale`
 * and follow the merchant's country, and only Canadian merchants can pick
 * between that country's languages (`en-CA`, `fr-CA`): elsewhere PayPal
 * ignores it or renders nothing, so it's left out.
 */
export const getPayPalMessagesLanguage = (
  store: string,
  locale: string | undefined,
): string | undefined =>
  store === 'reebelo-ca' && locale ? `${locale}-CA` : undefined;
